import config from "config";
import { useEffect, useState } from "react";
import { GetAssetsPathApiRequest } from "../api/AssetsManagementController";

/**
 * Fetch all assets paths and set them as css variables 
 * in order to use dynamic asset route in css.
 */
const useCssVars = () => {
  const [assetList, setAssetList] = useState<string[]>([]);

  useEffect(() => {
    // Get list of all paths to assets
    fetchAssets();
  }, []);

  useEffect(() => {
    if (assetList.length !== 0) {
      const baseAsssetUrl = `${config.api.resource}`;
      const root = document.documentElement;

      // Go through all assets and set them as css variables
      for (const assetPath of assetList) {
        // Replace all signs to dash in order to make valid css variable name
        const replaceAllSignsToDashRegEx = /[./_]/g;
        const varName = assetPath.replace(replaceAllSignsToDashRegEx, "-");

        const assetUrl = `${baseAsssetUrl}/${assetPath}`;
        root.style.setProperty(`--${varName}`, `url("${assetUrl}")`);
      }
    }
  }, [assetList]);

  const fetchAssets = async () => {
    const response = await GetAssetsPathApiRequest();
    setAssetList(response.data);
  };
};

export default useCssVars;
